import type { ChangeRequestFieldChange } from "@entrilia/shared/api/workflowTypes";
import type { NewBankAccountState } from "./newBankAccountState";

export const getBankDescription = (state: NewBankAccountState): string => {
  const { values, countryCode } = state.bankAccountForm;
  const iban = countryCode === "CA" ? "" : values.iban;

  return `${values.bankName} - ${(iban || values.accountNumber || "").slice(-4)}`;
};

export const getSelectedFunds = (state: NewBankAccountState): string[] =>
  state.fundAssignments.filter((fund) => fund.selected).map((fund) => fund.fundName);

export const getFieldChanges = (state: NewBankAccountState): ChangeRequestFieldChange[] => {
  const { values, countryCode } = state.bankAccountForm;
  const isCanada = countryCode === "CA";

  return (
    [
      { key: "Country", newValue: values.country, fieldType: "Text" },
      { key: "Bank Name", newValue: values.bankName, fieldType: "Text" },
      { key: "ABA Routing Number", newValue: countryCode === "US" ? values.abaNumber : "", fieldType: "Text" },
      { key: "SWIFT / BIC Code", newValue: values.swiftCode, fieldType: "Text" },
      { key: "Bank Street Address", newValue: isCanada ? values.bankAddress : "", fieldType: "Text" },
      { key: "Bank Street Address 2", newValue: isCanada ? values.bankAddress2 : "", fieldType: "Text" },
      { key: "Bank City", newValue: isCanada ? values.bankCity : "", fieldType: "Text" },
      { key: "Bank State / Province / Region", newValue: isCanada ? values.bankState : "", fieldType: "Text" },
      { key: "Bank ZIP / Postal Code", newValue: isCanada ? values.bankZipCode : "", fieldType: "Text" },
      { key: "Beneficiary Account Name", newValue: values.accountName, fieldType: "Text" },
      { key: "IBAN", newValue: isCanada ? "" : values.iban, fieldType: "Text" },
      { key: "Account Number", newValue: values.accountNumber, fieldType: "Text" },
      { key: "Currency", newValue: values.currencyCode, fieldType: "Text" },
      { key: "Institution Number", newValue: isCanada ? values.institutionNumber : "", fieldType: "Text" },
      { key: "Transit Number", newValue: isCanada ? values.transitNumber : "", fieldType: "Text" },
      { key: "FFC Name", newValue: values.ffcName, fieldType: "Text" },
      { key: "FFC Number", newValue: values.ffcAccountNumber, fieldType: "Text" },
    ] satisfies ChangeRequestFieldChange[]
  ).filter((change) => change.newValue);
};
